var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{on:{"click":_vm.toggleStatus}},[_vm._v("\n    "+_vm._s(this.status === this.referenceStatus ? this.enabledStatusLabel : this.disabledStatusLabel)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }